import moment from 'moment';

export default function (sortOrder) {
  return (value, nextValue) => {
    if (value === nextValue) return 0;

    if (!value) return nextValue ? 1 : 0;
    if (!nextValue) return -1;

    const firstDate = moment(value);
    const nextDate = moment(nextValue);

    if (!firstDate.isValid()) return 1;
    if (!nextDate.isValid()) return -1;

    if (nextDate.isAfter(firstDate)) return sortOrder === 'asc' ? -1 : 1;
    if (nextDate.isBefore(firstDate)) return sortOrder === 'asc' ? 1 : -1;

    return 0;
  };
}
